import http from '@/http/aisea/axios'
const resource = "/enterprises/background_tasks";

export default {

  fetch(payload) {
    return http.get(`${resource}`, {
      params: payload
    });
  },

  count(payload) {
    return http.get(`${resource}/count`, {
      params: payload
    });
  },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  update(id, payload) {
    return http.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return http.delete(`${resource}/${id}`);
  },



};
